// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca, catálogo e o
// carregador da tela. Outro módulo usa a `public.ts`.
export { BILLING_SETTING_PATH, billingSettingListScreen } from './billing-setting.screen';
export { billingSettingListSearch } from './billing-setting.search';
export { loadBillingSettingMessages, loadBillingSettingScreen } from './public';

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBillingSettingGuides = () => import('./billing-setting.guide');
